import { render } from "./ChangeOwnPasswordModal.vue?vue&type=template&id=6484fb54"
import script from "./ChangeOwnPasswordModal.vue?vue&type=script&lang=js"
export * from "./ChangeOwnPasswordModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__